export default "__VITE_ASSET__DkLiBHBn__"